import React from "react";
import { arrayOf, number, shape, string } from "prop-types";
import Button from "@insightfulscience/atomic-react/Button";
import Form from "@insightfulscience/atomic-react/Form";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import Select from "@insightfulscience/atomic-react/Select";
import FormField from "@insightfulscience/atomic-react/FormField";
import { classes } from "@insightfulscience/atomic-react/utils/classes";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import SimpleTemplateTitle from "@insightfulscience/atomic-react/SimpleTemplate/Title";
import SimpleTemplateDescription from "@insightfulscience/atomic-react/SimpleTemplate/Description";
import { useLocale } from "@insightfulscience/i18";
import currency from "@insightfulscience/smart-react/i18-formats/currency";
import Block from "@insightfulscience/atomic-react/Block";
import useSelectSeatsForm from "./hook";
import SelectSeatsMessage from "../SelectSeatsMessage";

const getSeats = ({ subscriptionSize }) => subscriptionSize;

const SelectSeatsForm = ({ priceList, planCode, initialSeats }) => {
	const [t] = useLocale("select-seats-form");

	const { seats, originSeats, price, updateSeats, inProcess, submitForm } = useSelectSeatsForm(
		priceList,
		planCode,
		initialSeats,
	);

	return (
		<>
			<SimpleTemplateTitle>{t("TITLE")}</SimpleTemplateTitle>
			<SimpleTemplateDescription>{t("DESCRIPTION")}</SimpleTemplateDescription>
			<Form
				noValidate
				onSubmit={submitForm}
				data-qa-selector="select-seats-form" // for e2e tesrts
			>
				<Row utility={{ justify: "center" }}>
					<Col sm={3}>
						<FormField
							required
							data-qa-selector="prices"
							Control={Select}
							id="prices"
							name="prices"
							value={seats}
							onChange={updateSeats}
							disabled={inProcess}
						>
							{Select.renderOptions(priceList, getSeats, getSeats)}
						</FormField>
					</Col>
				</Row>
				<Row utility={{ justify: "center" }}>
					<Col sm={8}>
						<SelectSeatsMessage seats={seats} originSeats={originSeats} />
					</Col>
				</Row>
				<Row>
					<Col>
						<Paragraph sx={{ fontSize: "xxxl", textAlign: "center" }} className="mt-4 mb-0">
							{currency(price)}
						</Paragraph>
						<Paragraph
							sx={{ fontSize: "s", textAlign: "center", textTransform: "uppercase" }}
							spacing={{ mt: 1, mb: 2 }}
						>
							{t("TOTAL")}
						</Paragraph>
					</Col>
					<Col spacing={{ mt: 4, mb: 2 }}>
						<Block sx={{ textAlign: "center" }}>
							<Button
								type="submit"
								disabled={inProcess}
								data-qa-selector="select-seats-submit-btn"
								className={classes(inProcess && "disabled")}
							>
								{t("CONTINUE")}
							</Button>
						</Block>
					</Col>
				</Row>
			</Form>
		</>
	);
};

SelectSeatsForm.propTypes = {
	priceList: arrayOf(
		shape({
			subscriptionSize: number.isRequired,
			price: number.isRequired,
			betterOption: number,
		}),
	).isRequired,
	planCode: string,
	initialSeats: number,
};
export default SelectSeatsForm;
